import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestState } from 'src/app/core/enums/enums';
import { SpecialRequestItem } from 'src/app/core/models/special-requests.model';
import { SpecialRequestTypes } from 'src/app/core/models/special.request.model';
import { SettingsService } from 'src/app/settings/services/settings.service';

@Component({
  selector: 'app-flight-special-requests',
  templateUrl: './flight-special-requests.component.html',
  styleUrls: ['./flight-special-requests.component.scss']
})
export class FlightSpecialRequestsComponent implements OnChanges, OnInit {
  @Input() specialRequest: SpecialRequestItem;
  @Input() type: SpecialRequestTypes;
  @Input() passenger: string;

  @Input() showBoth = false;
  @Input() showComparison = false;
  @Input() showSRequestValidation = false;
  @Input() sRequestValidationReady = false;
  @Input() sRequestValidationError = false;
  @Input() isCompatible = false;

  isAirline$: Observable<boolean>;

  constructor(private settingsService: SettingsService) {}

  ngOnInit() {
    this.isAirline$ = this.settingsService.getClientIsAirline();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes?.sRequestValidationReady?.currentValue) {
      this.sRequestValidationReady = true;
    }
  }

  requestState = RequestState;
  SRTypes = SpecialRequestTypes;
}
